<template>
    <div>
      <!-- 组件切换图文模块 -->
      <ul class="image-wrapper">
        <li v-for="(item, index) in listData" :key="index" @click="gotoDetails(item)">
          <img class="list-img" :src="item.images" alt="">
          <p class="list_date"> {{item.release_date}}</p>
          <p class="list-title">{{ item.title }}</p>
        </li>
      </ul>

    </div>
</template>
<script>
export default {
    comments: {
    },
    props: {
        imgPageData: {
            type: Array,
            default: () => ([])
        }
    },
    data(){
      return{
        listData: []
      }
    },
    mounted(){
    },
    methods: {
      // 跳转详情
        gotoDetails(item) {
          this.$router.push({
            path: '/storyDetails',
            query: {
                id: item.id,
                date: item.release_date
            }
          })
        },
        // 获取列表数据
        getlistdata(){
            for(var i = 0; i < this.listData.length; i++) {
                this.$set(this.listData[i], 'images', '')
                if (this.listData[i].image) {
                    this.getimage(i, this.listData[i].image)
                } else {
                    this.listData[i].images = require('@/assets/img/axs.png')
                }

            }
        },
        // 根据id进行获取图片
        async getimage(i,id){
          let res = await this.api.getinages(id)
          this.listData[i].images = window.URL.createObjectURL(res.data)
        },
        
    },
    watch: {
        imgPageData(n, o) {
            this.listData = n
            this.getlistdata()
        }
    }
}
</script>
<style lang="scss" scoped>
    .image-wrapper {
      display: flex;
      justify-content: flex-start; 
      flex-wrap: wrap;
      li {
        cursor: pointer;
        width: calc((100% - 20px) / 3);
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: center;
        margin-bottom: 20px;
        .list-img {
          width: 370px;
          height: 202px;
          background: #DCDCDC;
          border-radius: 8px 8px 8px 8px;
          opacity: 1;
        }
        .list_date{
          width: 370px;
          //width: 75%;
          text-align: right;
          margin-top: 5px;
        }
        .list-title {
           width: 340px;
            //width: 75%;
            margin-top: 10px;
            text-align: left;
            //height: 40px;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            /*! autoprefixer: off */
            -webkit-box-orient: vertical;
        }
      }
    }
</style>